import styled from 'styled-components';
import { Card as AntdCard } from 'antd';
import { QuestionCircleOutlined as AntdQuestionCircleOutlined } from '@ant-design/icons';
import { BaseForm } from '@app/components/common/forms/BaseForm/BaseForm';
import { Input, TextArea } from '@app/components/common/inputs/Input/Input';
export const StyledBaseForm = styled(BaseForm)`
  margin-top: 24px;
  .ant-form-item-label > label {
    font-size: 1.15rem;
    font-weight: 500;
    display: flex;
    align-items: center;
  }
`;

export const StyledInput = styled(Input)`
  width: 100%;
  font-size: 1.1rem;
`;

export const StyledTextArea = styled(TextArea)`
  width: 100%;
  font-size: 1.1rem;
`;

export const TooltipIcon = styled(AntdQuestionCircleOutlined)`
  margin-left: 8px;
`;

interface ResponseCardProps {
  $isSuccess: boolean;
}

export const ResponseCard = styled(AntdCard)<ResponseCardProps>`
  background-color: ${({ $isSuccess }) => ($isSuccess ? '#f6ffed' : '#fff2e8')};
  border-color: ${({ $isSuccess }) => ($isSuccess ? '#b7eb8f' : '#ffbb96')};
`;

export const PayloadPre = styled.pre`
  margin-top: 8px;
  padding: 8px;
  background-color: #f5f5f5;
  border-radius: 4px;
  overflow: auto;
  max-height: 200px;
  width: 100%;
  box-sizing: border-box;
  white-space: pre-wrap;
  word-break: break-word;
  overflow-wrap: anywhere;
`;
